import { useEffect, useState } from "react";
import { getActivePeriodId, onActivePeriodChange } from "../api/apiClient";

/**
 * Đợt đăng ký đang chọn (multi-period) dưới dạng reactive — re-render khi đổi đợt HOẶC khi
 * resolve xong (Hub adopt / bootstrap / combobox). 0 = chưa resolve / không có đợt.
 * Dùng để gate API call cần X-Period-Id.
 */
export const useActivePeriodId = (): number => {
    const [, forceRender] = useState(0);
    useEffect(() => onActivePeriodChange(() => forceRender(n => n + 1)), []);
    return getActivePeriodId() ?? 0;
};
